import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './sub-components/NavMenu';
import { SocialTop } from './sub-components/socialTop';
import { About } from './About';
import { MainImage } from './sub-components/MainImage';
import { VideoOverlay } from './sub-components/VideoOverlay';
import { Schedule } from './Schedule';
import { Footer } from './sub-components/Footer';
export class Layout extends Component {
    // Static property for debugging or identifying the component in DevTools
    static displayName = Layout.name;
    // The render method defines the UI structure
    render() {
        return (
            <div className="container">
                <NavMenu />
                {/*<SocialTop></SocialTop>*/}
                <MainImage></MainImage>
                {/*<About></About>*/}
                {/*`{this.props.children}` renders whatever child elements are passed into the Layout component (typically your page content).*/}
                <Container fluid={true} className="p-0 backer">
                    {this.props.children}
                </Container>
                {/*<VideoOverlay></VideoOverlay>*/}
                {/*<Backer></Backer>*/}
                {/*<Schedule></Schedule>*/}
                <Footer></Footer>
            </div>
        );
    }
}
